/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setDrawerButton.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ドロワーナビゲーションボタン
 */
const setDrawerButton = () => {
  let html = document.querySelector('html');
  let DrawerButton = document.querySelectorAll('.drawerButton__toggle');
  let Links = document.querySelectorAll('a[data-anchor="true"]');

  // ドロワーナビオープンorクローズ
  const navOpen = () => {
    html.classList.add("--open");
  }

  // ドロワーナビクローズ
  const navClose = () => {
    html.classList.remove("--open");
  }
  
  // ドロワーボタンクリック時
  DrawerButton.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (html.classList.contains("--open")) {
        navClose();
      } else {
        navOpen();
      }
    });
  })

  // アンカーリンククリック時
  Links.forEach((link) => {
    link.addEventListener("click", navClose);
  })
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  setDrawerButton
};